module.exports = __webpack_public_path__ + "user-default.png?22388de38ab45f5880122bed53c8c2e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-default.png
// module id = 324
// module chunks = 0